import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { DropdownButton } from "components/alove/DropDownButton";
import { addAlert, useMaterialUIController } from "context";
import { BatchUIMobile } from "models/batch/BatchContent";
import React, { useState } from "react";
import { createBatchContentDO, updateBatchContentDO } from "utils/questionsUtils";

const MDInput = require("components/MDInput").default;

interface TextQuestionDialogProps {
  questionaireID: number;
  onSuccess?: () => void;
}

export const TextQuestionDialog = ({ questionaireID, onSuccess }: TextQuestionDialogProps) => {
  const [controller, dispatch] = useMaterialUIController();
  const [text, setText] = useState("");
  const [form, setForm] = useState(BatchUIMobile.Message);

  const handleSubmit = async () => {
    try {
      await createBatchContentDO({
        batchId: questionaireID,
        text,
        visSettings: {
            ui_mobile: form
        }
      });
      addAlert(dispatch, "Text added successfully");
      setText("");
      onSuccess?.();
    } catch (error) {
      addAlert(dispatch, "Failed to add text", true);
    }
  };

  return (
    <AloveDialog
      dialogType={DialogType.AddTextQuestion}
      dialogTitle="Add Text"
      dialogBody="Enter the text"
      dialogConfirm="Add"
      valid={text.length > 0}
      handleConfirm={handleSubmit}
      handleDismis={() => setText("")}
    >
      <MDInput
        label="Text"
        placeholder="Enter your text"
        required
        multiline
        rows={3}
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      <DropdownButton
        label="Message"
        options={Object.keys(BatchUIMobile).map(key => ({
          label: key,
          value: BatchUIMobile[key]
        }))}
       
        
        onClick={(e) => setForm(e.value)}
      />
    </AloveDialog>
  );
}; 